/*= ========================================================================================
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization  (TODO: Implement this functionality - pending approbation from carlos)
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
========================================================================================== */

export default [
        {
                url: '/',
                name: 'Inicio',
                slug: 'home',
                icon: 'HomeIcon',
        },
        {
                name: 'Finanzas',
                slug: 'finanzas',
                icon: 'TrendingUpIcon',
                submenu: [
                        {
                                name: 'Invoices',
                                slug: 'invoices',
                                iconName: 'invoice',
                                iconFamily: 'local',
                                submenu: [
                                        {
                                                url: '/finances/invoices/create',
                                                name: 'Nueva Factura',
                                                slug: 'createInvoice',
                                        },
                                ],
                        },
                ],
        },
        {
                name: 'Usuarios',
                slug: 'usuarios',
                icon: 'UsersIcon',
                url: '/users',
                submenu: [
                        {
                                url: '/users',
                                name: 'Listar Clientes',
                                slug: 'listInvoices',
                        },
                        {
                                url: '/users/create',
                                name: 'Nuevo Cliente',
                                slug: 'createInvoice',
                        },
                        {
                                url: '/users/create/pet',
                                name: 'Nueva Mascota',
                                slug: 'createPet',
                        },
                        {
                                url: '/users/create/vehicle',
                                name: 'Nuevo vehículo',
                                slug: 'createVehicle',
                        },
                ],
        },
        {
                name: 'Copropiedades',
                slug: 'copropiedades',
                iconName: 'city',
                iconFamily: 'local',
                submenu: [
                        {
                                url: '/conjuntos',
                                name: 'Listar Conjuntos',
                                slug: 'listConjuntos',
                                iconName: 'far fa-city',
                                iconFamily: 'fa5',
                        },
                        {
                                name: 'Bloques',
                                slug: 'bloques',
                                iconName: 'far fa-building',
                                iconFamily: 'fa5',
                                submenu: [
                                        {
                                                url: '/conjuntos/bloques',
                                                name: 'Listar Bloques',
                                                slug: 'listBloques',
                                        },
                                        {
                                                url: '/conjuntos/bloques/create',
                                                name: 'Nuevo Bloque',
                                                slug: 'createBloque',
                                        },
                                ],
                        },
                ],
        },
        {
                url: '/settings',
                name: 'Configuracion',
                slug: 'configuracion',
                icon: 'SettingsIcon',
        },
];
